export default __webpack_public_path__ + "static/media/stormstrike.cde2b4e0.png";